const RGROUPS = {
  GLOBAL : {
    verbose: 'Global',
    number: 193
  },
  AFG : {
    verbose: 'African Group',
    number: 54
  },
  APG : {
    verbose: 'Asia-Pacific Group',
    number: 53
  },
  EEG : {
    verbose: 'Eastern European Group',
    number: 23
  },
  GRULAC : {
    verbose: 'Latin American and Caribbean Group',
    number: 33
  },
  WEOG : {
    verbose: 'Western European and Others Group',
    number: 29
  }
};

export default RGROUPS;



// WEBPACK FOOTER //
// ./src/resources/political-constants.js